import { useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Avatar as TooltipAvatar } from 'app/components/withTooltip';
import { Table, TableRowActionsCell } from 'altus-ui-components';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { EMPTY_LIST, Format } from 'app/app.constants';
import moment from 'moment';
import { ACTIVITY_TYPES } from 'features/wells/overview/activityLog/helpers/activityLog.constants';
import StatusChip from 'features/wells/overview/activityLog/components/StatusChip';
import ActivityLogsTableRow from 'features/wells/overview/activityLog/ActivityLogsTableRow';

const FieldActivityLogsTable = ({ activityLogs = EMPTY_LIST }) => {
  const columns = useMemo(
    () => [
      {
        id: 'expansionIcon',
        Header: <TableRowActionsCell minItems={1} />,
        Cell: () => (
          <TableRowActionsCell>
            <ExpandMoreIcon />
          </TableRowActionsCell>
        ),
      },
      {
        xs: 2,
        Header: 'Activity',
        accessor: (log) => log.activityName,
      },
      {
        xs: 2,
        Header: 'Well',
        accessor: (log) => log.wellboreName,
      },
      {
        xs: 2,
        Header: 'Start Date',
        accessor: (log) => moment(log.startDate).format(Format.date_dayfirst),
      },
      {
        xs: 2,
        Header: 'End Date',
        accessor: (log) => moment(log.endDate).format(Format.date_dayfirst),
      },
      {
        xs: 1,
        Header: 'Type',
        accessor: (log) =>
          ACTIVITY_TYPES.find((type) => type.id === log.activityType).name,
      },
      {
        xs: 2,
        Header: 'Status',
        accessor: (log) => <StatusChip status={log.status} />,
      },
      {
        xs: 2,
        Header: 'Responsible',
        accessor: (log) => log.responsibleUser?.fullName,
        Cell: ({ row }) => {
          const user = row.original.responsibleUser;

          return user ? (
            <Grid container alignItems={'center'}>
              <Grid item xs={2}>
                <TooltipAvatar title={user.fullName} src={user.avatar}>
                  {!user.avatar && user.initials}
                </TooltipAvatar>
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={6}>
                <Typography variant="body2">{user.fullName}</Typography>
              </Grid>
            </Grid>
          ) : (
            '-'
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Table
        items={activityLogs.size > 0 ? activityLogs : EMPTY_LIST}
        columns={columns}
        useGlobalFilter={false}
        noItemsMessage="No Activity has been added yet."
        TableRowComponent={ActivityLogsTableRow}
      />
    </>
  );
};

export default FieldActivityLogsTable;
